import {useSagaCallback} from "../utils/sagas";
import {apiPost} from "./client";
import {useCallback} from "react";
import {call} from "redux-saga/effects";

export const useReset = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (username, email) {
        yield call(apiPost, `/api/v2/account/reset`, {
            username, email
        });
    }, []))
};

export const useRecover = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (token, password) {
        yield call(apiPost, `/api/v2/account/recover`, {
            token, password
        });
    }, []))
};
